import React, { FC, useContext, useState } from 'react'
import { Button, Card, Empty, Flex } from 'antd'
import { ParcelIcon } from '../../../component/icon'
import { translate } from '../../../core'
import { PlusOutlined } from '@ant-design/icons'
import { PurchaseOrderListItemParcelEntryForm } from './PurchaseOrderListItemParcelEntryForm'
import { dateDisplay, usdFormat } from '../../../core/until'
import { PurchaseOrderListItemContext } from './PurchaseOrderListItemContext'

export const PurchaseOrderListItemParcel: FC = () => {
  const {entity} = useContext(PurchaseOrderListItemContext)
  const [isReceiving, setIsReceiving] = useState<boolean>(true)

  const canReceive = entity.status === 'Confirmed' || entity.status === 'PartiallyReceived'

  const orderedDescriptionByItemId = new Map(
    entity.items
      .filter(it => !!it.description)
      .map(it => [it.item.id, it.description as string])
  )

  return (
    <Card className='w-100 border'>
      <Flex align='center'>
        <Flex className='w-50' align='center'>
          <ParcelIcon size={25}/>
          <span className='fs-4 ms-2'>{translate('parcel_delivery')}</span>
        </Flex>
        <Flex className='w-50' justify='end'>
          {canReceive && !isReceiving
            ? <Button
              onClick={() => setIsReceiving(true)}
              type='primary'
              icon={<PlusOutlined/>}
            >
              {translate('receive_purchase_order')}
            </Button>
            : null}
        </Flex>
      </Flex>

      {canReceive
        ? <div hidden={!isReceiving}>
          <PurchaseOrderListItemParcelEntryForm
            key={entity.parcelDelivery.length}
            onClose={() => setIsReceiving(false)}
          />
        </div>
        : null}

      <div className='mt-4'>
        <span className='fs-5'>{translate('delivery', 'history')}</span>

        <div className='mt-3'>
          {entity.parcelDelivery.length
            ? entity.parcelDelivery.map((pd, pdIndex) => (
              <Card key={pdIndex} className='w-100 border mt-3' size='small'>
                <div className='f-medium fw-bold mb-2'>
                  {translate('delivery', 'date')}: {dateDisplay(pd.date)}
                </div>

                <table className='table align-middle f-medium mb-0'>
                  <thead>
                  <tr className='text-muted'>
                    <th>
                      {translate('sku')}
                    </th>
                    <th>
                      {translate('description')}
                    </th>
                    <th className='text-end'>
                      {translate('quantity', 'received')}
                    </th>
                    <th className='text-end'>
                      {translate('cost_price')}
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                  {pd.items.sort((a, b) => a.quantity - b.quantity).map((it, itemIndex) => (
                    <tr key={itemIndex}>
                      <td>
                        {it.item.sku}
                      </td>
                      <td>
                        {orderedDescriptionByItemId.get(it.item.id) ?? it.item.description}
                      </td>
                      <td className='text-end'>
                        {it.quantity}
                      </td>
                      <td className='text-end'>
                        {it.costPrice != null ? usdFormat(it.costPrice) : '-'}
                      </td>
                    </tr>
                  ))}
                  </tbody>
                </table>
              </Card>
            ))
            : <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={translate('no', 'delivery', 'history')}
            />}
        </div>
      </div>
    </Card>
  )
}
